export const NOTICE_WITH_OUT_AUTH_REQUEST = 'NOTICE_WITH_OUT_AUTH_REQUEST';
export const NOTICE_WITH_OUT_AUTH_SUCCESS = 'NOTICE_WITH_OUT_AUTH_SUCCESS';
export const NOTICE_WITH_OUT_AUTH_FAIL    = 'NOTICE_WITH_OUT_AUTH_FAIL';

